export default __webpack_public_path__ + "static/media/6610ab7c52eec57a14a5d8e850abbfa31598728847569.1fbefda2.webp";